const DawanOrg = "https://dawan.org";

export default {
  DawanHome: "https://dawan.fr",
  DawanLogo: "https://www.dawan.fr/build/images/dawan-logo.5b6f94e2.png",

  DawanOrgShowTrainingSession: (slug) =>
    `${DawanOrg}/TrainingSession/show/${slug}`,
  DawanOrgShowTask: (slug) => `${DawanOrg}/Task/show/${slug}`,
  DawanOrgShowPerson: (slug) => `${DawanOrg}/Person/show/${slug}`,
  DawanOrgShowPreparationCall: (slug) =>
    `${DawanOrg}/PreparationCall/show/${slug}`,
  DawanOrgShowSessionOption: (slug) => `${DawanOrg}/SessionOption/show/${slug}`,
  DawanOrgShowEstimate: (slug) => `${DawanOrg}/Estimate/show/${slug}`,

  CalendarGetHolidays:
    "https://calendrier.api.gouv.fr/jours-feries/metropole.json",
};
